import React from "react";
import {
    FooterSection,
    FooterInner,
    FooterLogo,
    FooterTagline,
    FooterColumns,
    FooterColumn,
    FooterColumnTitle,
    FooterLink,
    FooterDivider,
    FooterBottom,
    FooterCopyright
} from './styled';

export default function FaleConosco() {
    return (
        <FooterSection>
            <FooterInner>
                {/* Logo e tagline */}
                <FooterLogo>
                    <img src="/icons/logo_tiq_chat.png" alt="TiqChat" width="140" height="46" />
                    <FooterTagline>Sabedoria que atravessa séculos, ao seu alcance.</FooterTagline>
                </FooterLogo>

                {/* Colunas de links */}
                <FooterColumns>
                    <FooterColumn>
                        <FooterColumnTitle>Plataforma</FooterColumnTitle>
                        <FooterLink href="/register">Criar conta grátis</FooterLink>
                        <FooterLink href="/login">Entrar</FooterLink>
                        <FooterLink href="/planos">Ver planos</FooterLink>
                    </FooterColumn>

                    <FooterColumn>
                        <FooterColumnTitle>Personagens</FooterColumnTitle>
                        <FooterLink as="span">Rei Salomão</FooterLink>
                        <FooterLink as="span">Rei Davi</FooterLink>
                        <FooterLink as="span">Rainha Ester</FooterLink>
                        <FooterLink as="span">Profeta Daniel</FooterLink>
                    </FooterColumn>

                    <FooterColumn>
                        <FooterColumnTitle>Contato</FooterColumnTitle>
                        <FooterLink
                            href="https://wa.me/5516982026554?text=Olá!%20Tenho%20uma%20dúvida%20sobre%20o%20TiqChat."
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            WhatsApp (16) 98202-6554
                        </FooterLink>
                        <FooterLink href="mailto:faglimar@stonel19.com">
                            faglimar@stonel19.com
                        </FooterLink>
                    </FooterColumn>

                    <FooterColumn>
                        <FooterColumnTitle>Legal</FooterColumnTitle>
                        <FooterLink href="/termos-de-uso">Termos de Uso</FooterLink>
                        <FooterLink href="/politica-de-privacidade">Política de Privacidade</FooterLink>
                    </FooterColumn>
                </FooterColumns>
            </FooterInner>

            <FooterDivider />

            <FooterBottom>
                <FooterCopyright>
                    © {new Date().getFullYear()} TiqChat · Stonel19 Soluções em IA Gen Ltda · CNPJ 61.577.764/0001-39
                </FooterCopyright>
            </FooterBottom>
        </FooterSection>
    );
}
